import * as actionTypes from "./actionTypes";
import axios from 'axios';

export const initGetWishList = () => {
    return {
        type: actionTypes.INIT_GET_WISHLIST,
        wishListLoading: true
    }
};

export const successGetWishList = (data) => {
    return {
        type: actionTypes.SUCCESS_GET_WISHLIST,
        whishListItems: data,
        wishListLoading: false
    }
};

export const failGetWishList = (error) => {
    return {
        type: actionTypes.FAIL_GET_WISHLIST,
        error: error,
        wishListLoading: false
    }
};

const wishIds = (data) => {
    const wishIdsArray = [];
    data.data.map(item => {
        return wishIdsArray.push(item.model_id)
    });
    localStorage.setItem('myWish', wishIdsArray)
    return {
        type: actionTypes.WISH_IDS_ARRAY,
        wishIdsArray: wishIdsArray
    }

}


export const getWishList = (bearerToken, withLoading = true) => {
    const config = {
        headers: {
            Authorization: "Bearer " + bearerToken
        }
    }
    return dispatch => {
        if (withLoading) {
            dispatch(initGetWishList());
        }
        axios.get('all/lists/wishlisted', config)
            .then(response => {
                dispatch(wishIds(response.data))
                dispatch(successGetWishList(response.data))
            })
            .catch(error => {
                dispatch(failGetWishList(error.message))
            })
    }
};

// ####################################### ADDING NEW ITEM TO WIHSLIST ###########################

export const initAddItemToUserWishList = () => {
    return {
        type: actionTypes.INIT_ADD_ITEM_TO_USER_WISHLIST,
        addingItem: true
    }
};

export const successAddItemToUserWishList = () => {
    return {
        type: actionTypes.SUCCESS_ADD_ITEM_TO_USER_WISHLIST,
        addingItem: false
    }
};

export const failAddItemToUserWishList = (error) => {
    return {
        type: actionTypes.FAIL_ADD_ITEM_TO_USER_WISHLIST,
        addingItem: false,
        error: error
    }
};


export const addItemToUserWishList = (itemId, bearerToken) => {
    const config = {
        headers: {
            Authorization: "Bearer " + bearerToken
        }
    }
    return dispatch => {
        dispatch(initAddItemToUserWishList())
        axios.post(`all/lists/${itemId}/wish`, null, config)
            .then(response => {
                dispatch(getWishList(bearerToken));
                dispatch(successAddItemToUserWishList())
            })
            .catch(error => {
                dispatch(failAddItemToUserWishList(error.message))
            })
    }
};


// ####################################### REMOVING  ITEM FROM WIHSLIST ###########################


export const initRemoveItemFromUserWishList = () => {
    return {
        type: actionTypes.INIT_REMOVE_ITEM_FROM_USER_WISHLIST,
        removing: true
    }
};

export const successRemoveItemFromUserWishList = () => {
    return {
        type: actionTypes.INIT_REMOVE_ITEM_FROM_USER_WISHLIST,
        removing: false
    }
};

export const failRemoveItemFromUserWishList = (error) => {
    return {
        type: actionTypes.INIT_REMOVE_ITEM_FROM_USER_WISHLIST,
        error: error,
        removing: false
    }
};

export const removeItemFromUserWishList = (itemId, bearerToken) => {
    const config = {
        headers: {
            Authorization: "Bearer " + bearerToken
        }
    }
    return dispatch => {
        dispatch(initRemoveItemFromUserWishList());
       
        axios.delete(`all/lists/${itemId}/wish`, config)
            .then(response => {
                dispatch(getWishList(bearerToken, false))
                dispatch(successRemoveItemFromUserWishList())
            })
            .catch(error => {
                failRemoveItemFromUserWishList(error.message)
            })
    }
};